import { Control } from "ol/control";


/**
 * Just a control component to make a legend.
 */
export class RiskSectorControl extends Control {
	cachedZoneIdentity = 0;

	infrastructureNode = null;

	openSymbol = "&plus;";
	closeSymbol = "&minus;"

	constructor() {
		let articleNode = document.createElement("article");
		articleNode.className = "ol-unselectable ol-control";
		articleNode.id = "riskContainer";

		// Apply custom styles for positioning and appearance
		articleNode.style.display = "none";
		articleNode.style.position = "absolute";
		articleNode.style.top = "1rem"; 
		articleNode.style.left = "2vw";  
		articleNode.style.backgroundColor = "rgba(255, 255, 255, 1)"; 
		articleNode.style.padding = "4px 4px"; 
		articleNode.style.borderRadius = "6px"; 
		articleNode.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.15)"; 
		articleNode.style.minWidth = "600px";
		articleNode.style.width = "58vw";
		articleNode.style.height = "auto";
		super({ element: articleNode });

		this.popupHeaderFactory();
		this.infoSectionFactory();

		this.cachedZoneIdentity = 0;

		const toggleSlideBtn = document.createElement("button");
		toggleSlideBtn.innerHTML = `
			<?xml version="1.0" ?>
			<!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'>
			<svg enable-background="new 0 0 32 32" height="20px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="data">
				<path d="M16,0C9.256,0,2,2.033,2,6.5v19C2,29.965,9.256,32,16,32c6.743,0,14-2.035,14-6.5v-19   C30,2.033,22.742,0,16,0z M28,25.5c0,2.484-5.373,4.5-12,4.5c-6.628,0-12-2.016-12-4.5v-3.736C6.066,23.893,11.05,25,16,25   c4.95,0,9.934-1.107,12-3.236V25.5z M28,19.5h-0.004c0,0.01,0.004,0.021,0.004,0.031C28,22,22.627,24,16,24c-6.627,0-12-2-12-4.469   c0-0.01,0.004-0.021,0.004-0.031H4v-3.736C6.066,17.893,11.05,19,16,19c4.95,0,9.934-1.107,12-3.236V19.5z M28,13.5h-0.004   c0,0.01,0.004,0.021,0.004,0.031C28,16,22.627,18,16,18c-6.627,0-12-2-12-4.469c0-0.01,0.004-0.021,0.004-0.031H4v-3.436   C6.621,12.061,11.425,13,16,13c4.575,0,9.379-0.939,12-2.936V13.5z M16,11C9.372,11,4,8.984,4,6.5C4,4.014,9.372,2,16,2   c6.627,0,12,2.014,12,4.5C28,8.984,22.627,11,16,11z" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2"/>
				<circle cx="25" cy="26" fill="#FFFFFF" r="1.5"/>
				<circle cx="25" cy="20" fill="#FFFFFF" r="1.5"/>
				<circle cx="25" cy="14" fill="#FFFFFF" r="1.5"/>
			</g>
			</svg>
		`;

		const svg = toggleSlideBtn.querySelector("svg");
		svg.style.transform = "translate(-10px, -10px)";
		toggleSlideBtn.style.position = "absolute";
		toggleSlideBtn.style.top = "50%";
		toggleSlideBtn.style.right = "-39px";
		toggleSlideBtn.style.padding = "1rem";
		toggleSlideBtn.style.paddingLeft = "1.4rem";
		toggleSlideBtn.style.backgroundColor = "#7f9dc3";
		toggleSlideBtn.style.color = "white";
		toggleSlideBtn.style.border = "none";
		toggleSlideBtn.style.borderTopRightRadius = "50%";
		toggleSlideBtn.style.borderBottomRightRadius = "50%";
		toggleSlideBtn.style.cursor = "pointer";
		toggleSlideBtn.style.transition = "right 0.3s ease"; // Smooth transition for button movement

		let isSliding = false;

		toggleSlideBtn.onclick = () => {
			if (isSliding) {
				articleNode.style.transform = "translateX(0)";
			} else {
				articleNode.style.transform = "translateX(-104%)";
			}
			isSliding = !isSliding;
		};


		articleNode.append(toggleSlideBtn);

		// Apply smooth transition for the graphContainer
		articleNode.style.transition = "transform 0.5s ease";

	}

	calculateSum = (data, keys) => {
		return keys.reduce((sum, key) => sum + (data[key] || 0), 0);
	};

	popupHeaderFactory = () => {
		const headerNode = document.createElement("header");
		headerNode.className = "legendRow";
		headerNode.style.marginLeft = "0.94rem";
		headerNode.style.marginBottom = "0.94rem";

		const headerTitleNode = document.createElement("strong");
		headerTitleNode.innerText = "Izpostavljeni objekti";

		headerNode.append(headerTitleNode);

		const closeButton = document.createElement("button");
		closeButton.type = "button";
		closeButton.innerHTML = "&times;";
		closeButton.style.marginLeft = "auto";

		closeButton.onclick = (clickEvent) => {
			if (clickEvent.cancelable) clickEvent.preventDefault();
			if (clickEvent.bubbles) clickEvent.stopPropagation();

			this.element.style.display = "none";
		};

		headerNode.append(closeButton);

		this.element.append(headerNode);
	};



	infoSectionFactory = () => {
		const infoSection = document.createElement("section");

		infoSection.id = "infrastructureSection";

		this.element.append(infoSection);

		this.infrastructureNode = infoSection;
	};



	replaceRiskZoneStatistic = (riskZoneData) => {
		if (!riskZoneData) {
			console.error("No risk-zone data passed, aborting");
			return;
		}

		this.element.style.display = "";

		if (riskZoneData.id === this.cachedZoneIdentity) return;

		this.cachedZoneIdentity = riskZoneData.id;

		
		this.createInfrastructureNodes(riskZoneData)
		this.createRoadButton(riskZoneData);
		this.createLandButton(riskZoneData);
		this.communicationInfrastructure(riskZoneData, riskZoneData);
		this.lightingInfrastructure(riskZoneData);

		this.electricityNode(riskZoneData);

		this.waterInfrastructureButton(riskZoneData);
	};

	createInfrastructureNodes = (riskZoneData) => {
		// Clear existing content in infrastructureNode
		this.infrastructureNode.innerHTML = "";
	
		// Create a container for the infrastructure node
		const containerNode = document.createElement("div");
		containerNode.classList.add("infrastructure-node");
	
		// Create the image element for the icon
		const iconNode = document.createElement("img");
		iconNode.classList.add("icon");
		iconNode.src = "img/houseIcon.png"; // Replace with the path to your image
		iconNode.alt = "Infrastructure Icon"; // Add alt text for accessibility
	
		// Create the description text node
		const descriptionNode = document.createElement("div");
		descriptionNode.classList.add("description");
		descriptionNode.innerText = "Zgradbe: " + riskZoneData.buildings;
	
		// Append the icon and description to the container
		containerNode.appendChild(iconNode);
		containerNode.appendChild(descriptionNode);
	
		// Append the whole container to the infrastructureNode
		this.infrastructureNode.append(containerNode);
	};
	

	createLandButton = (mapElementData) => {
		if (!mapElementData) return;
	
		// Create the main container for Land Infrastructure
		const landNode = document.createElement("div");
		landNode.className = "legendRow infrastructure-node";
	
		// Create the icon element for Land
		const landIcon = document.createElement("img");
		landIcon.className = "icon";
		landIcon.src = "img/landIcon.png"; // Replace with your icon's path
		landIcon.alt = "Land Icon";
	
		// Create the description text node
		const landDescription = document.createElement("div");
		landDescription.className = "description";
		let LandUsageSum = mapElementData.garden + mapElementData.plantation + mapElementData.grassland + mapElementData.other + mapElementData.forest + mapElementData.non + mapElementData.waterland;
	
		const sectionUnit = " m²";
	
		landDescription.innerHTML = "Raba tal: " + LandUsageSum + sectionUnit;
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append the icon, description, and dropdown indicator to the land node
		landNode.appendChild(landIcon);
		landNode.appendChild(landDescription);
		landNode.appendChild(dropdownIndicator);
	
		// Create the floating submenu for Land Infrastructure details
		const landSubmenu = document.createElement("ul");
		landSubmenu.className = "floatingList";
		landSubmenu.style.display = "none"; // Hidden by default
		landSubmenu.style.position = "absolute"; // Position it absolutely
		landSubmenu.style.top = "100%"; // Position it directly below the button
	
		// Prepare the data for the floating list
		const landDetails = [
			{ label: "Polje ali vrt", value: mapElementData.garden, unit: "m²" },
			{ label: "Nasad", value: mapElementData.plantation, unit: "m²" },
			{ label: "Travnik", value: mapElementData.grassland, unit: "m²" },
			{ label: "Druge kmetijske površine", value: mapElementData.other, unit: "m²" },
			{ label: "Gozd", value: mapElementData.forest, unit: "m²" },
			{ label: "Neobdelovana zemlja", value: mapElementData.non, unit: "m²" },
			{ label: "Vodni zbiralnik", value: mapElementData.waterland, unit: "m²" }
		];
	
		// Add each item to the land submenu
		landDetails.forEach(({ label, value, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${value || 0}${unit || ""}`;
			landSubmenu.appendChild(listItem);
		});
	
		// Create the grid cell and append the landNode and floating submenu
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(landNode);
		gridCell.appendChild(landSubmenu);
	
		// Toggle submenu visibility on hover
		gridCell.onmouseenter = () => {
			landSubmenu.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const submenuRect = landSubmenu.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center submenu under the grid cell (move 25px to the left)
			const submenuLeft = gridCellRect.left + (gridCellRect.width / 2) - (submenuRect.width / 2) - 25; // Move 25px left
			landSubmenu.style.left = `${submenuLeft}px`;
	
			// Prevent submenu from going out of the window (horizontally)
			if (submenuLeft < 0) {
				landSubmenu.style.left = "0"; // Align to the left of the viewport
			} else if (submenuLeft + submenuRect.width > windowWidth) {
				landSubmenu.style.left = `${windowWidth - submenuRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			// Hide submenu
			landSubmenu.style.display = "none";
		};
	
		// Append the grid cell to the infrastructure node
		this.infrastructureNode.appendChild(gridCell);
	};
	
	
	
	createRoadButton = (mapElementData) => {
		if (!mapElementData) return;
	
		// Create the main container for Road Infrastructure
		const roadNode = document.createElement("div");
		roadNode.className = "legendRow infrastructure-node";
	
		// Create the icon element for the road
		const roadIcon = document.createElement("img");
		roadIcon.className = "icon";
		roadIcon.src = "img/roadIcon.png"; // Replace with your icon's path
		roadIcon.alt = "Road Icon";
	
		// Create the description text node
		const roadDescription = document.createElement("div");
		roadDescription.className = "description";
		let roadSum = mapElementData.local + mapElementData.forest_road + mapElementData.cycling + mapElementData.highway;
		roadDescription.innerText = "Ceste: " + roadSum + " m";
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append the icon, description, and dropdown indicator to the road node
		roadNode.appendChild(roadIcon);
		roadNode.appendChild(roadDescription);
		roadNode.appendChild(dropdownIndicator);
	
		// Create the floating submenu for Road Infrastructure details
		const roadSubmenu = document.createElement("ul");
		roadSubmenu.className = "floatingList";
		roadSubmenu.style.display = "none"; // Hidden by default
		roadSubmenu.style.position = "absolute"; // Position it absolutely
		roadSubmenu.style.top = "100%"; // Position it directly below the button
	
		// Prepare the data for the floating list
		const roadDetails = [
			{ label: "Lokalne ceste", value: mapElementData.local, unit: "m" },
			{ label: "Gozdne steze", value: mapElementData.forest_road, unit: "m" },
			{ label: "Kolesarske steze", value: mapElementData.cycling, unit: "m" },
			{ label: "Avtocesta", value: mapElementData.highway, unit: "m" }
		];
	
		// Add each item to the road submenu
		roadDetails.forEach(({ label, value, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${value || 0}${unit || ""}`;
			roadSubmenu.appendChild(listItem);
		});
	
		// Create the grid cell and append the roadNode and floating submenu
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(roadNode);
		gridCell.appendChild(roadSubmenu);
	
		// Toggle submenu visibility on hover
		gridCell.onmouseenter = () => {
			roadSubmenu.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const submenuRect = roadSubmenu.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center submenu under the grid cell (shift it 25px to the left)
			const submenuLeft = gridCellRect.left + (gridCellRect.width / 2) - (submenuRect.width / 2) - 25; // Move 25px left
			roadSubmenu.style.left = `${submenuLeft}px`;
	
			// Prevent submenu from going out of the window (horizontally)
			if (submenuLeft < 0) {
				roadSubmenu.style.left = "0"; // Align to the left of the viewport
			} else if (submenuLeft + submenuRect.width > windowWidth) {
				roadSubmenu.style.left = `${windowWidth - submenuRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			roadSubmenu.style.display = "none";
		};
	
		// Append the grid cell to the infrastructure node
		this.infrastructureNode.appendChild(gridCell);
	};
	

	electricityNode = (mapElementData) => {
		if (!mapElementData) return;
	
		// Create the main electricity button container
		const electricityNode = document.createElement("div");
		electricityNode.className = "legendRow infrastructure-node"; // Reuse the same styling classes
	
		// Create the image element for the icon
		const iconNode = document.createElement("img");
		iconNode.classList.add("icon");
		iconNode.src = "img/electricityIcon.png"; // Replace with the path to your image
		iconNode.alt = "Electricity Icon"; // Add alt text for accessibility
	
		// Create the description text node
		const descriptionNode = document.createElement("div");
		descriptionNode.classList.add("description");
		descriptionNode.innerText = "Električna napeljava";
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append icon, description, and indicator to the electricity button
		electricityNode.appendChild(iconNode);
		electricityNode.appendChild(descriptionNode);
		electricityNode.appendChild(dropdownIndicator);
	
		// Create the floating submenu (first floating list)
		const floatingSubmenu = document.createElement("ul");
		floatingSubmenu.className = "floatingList";
		floatingSubmenu.style.display = "none"; // Hidden by default
		floatingSubmenu.style.position = "absolute"; // Position it absolutely
		floatingSubmenu.style.top = "100%"; // Position it directly below the button
	
		// Add each item to the submenu
		const subMenuItems = [
			{ label: "Podzemni električni vodi", details: mapElementData.buried, unit: "m" },
			{ label: "Nadzemni električni vodi", details: mapElementData.hanged, unit: "m" },
			{ label: "Javna razsvetljava", details: mapElementData.lighting, unit: "m" },
			{ label: "Jašek/Cev", details: mapElementData.el_shaft, unit: "" },
			{ label: "Napajalnik", details: mapElementData.el_base, unit: "" },
			{ label: "Transformatorska postaja", details: mapElementData.station, unit: "" }
		];
	
		subMenuItems.forEach(({ label, details, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${details || 0}${unit || ""}`;
			floatingSubmenu.appendChild(listItem);
		});
	
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(electricityNode);
		gridCell.appendChild(floatingSubmenu);
	
		// Toggle submenu visibility on hover
		gridCell.onmouseenter = () => {
			// Show submenu
			floatingSubmenu.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const submenuRect = floatingSubmenu.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center submenu under the grid cell (adjusted 25px to the left)
			const submenuLeft = gridCellRect.left + (gridCellRect.width / 2) - (submenuRect.width / 2) - 25; // Move 25px left
			floatingSubmenu.style.left = `${submenuLeft}px`;
	
			// Prevent submenu from going out of the window (horizontally)
			if (submenuLeft < 0) {
				floatingSubmenu.style.left = "0"; // Align to the left of the viewport
			} else if (submenuLeft + submenuRect.width > windowWidth) {
				floatingSubmenu.style.left = `${windowWidth - submenuRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			// Hide submenu
			floatingSubmenu.style.display = "none";
		};
	
		// Append the grid cell to the infrastructure node
		this.infrastructureNode.append(gridCell);
	};
	

	
	communicationInfrastructure = (mapElementData, riskZoneData) => {
		if (!mapElementData) return;
	
		// Create the main container for Communication Infrastructure
		const communicationNode = document.createElement("div");
		communicationNode.className = "legendRow infrastructure-node"; // Reuse the same styling classes
	
		// Create the icon element
		const iconNode = document.createElement("img");
		iconNode.classList.add("icon");
		iconNode.src = "img/antennaIcon.png"; // Replace with the path to your icon
		iconNode.alt = "Communication Icon"; // Add alt text for accessibility
	
		// Create the description text node
		const descriptionNode = document.createElement("div");
		descriptionNode.classList.add("description");
		let partsSum = mapElementData.a_pole + mapElementData.single_base + mapElementData.shaft + mapElementData.auxiliary + mapElementData.cabinet_base + mapElementData.cabinet_wall + mapElementData.cabinet_duplicate + mapElementData.location;
		descriptionNode.innerText = "Elementi telekomunikacijskega omrežja: " + partsSum;
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append icon, description, and dropdown indicator to the communication node
		communicationNode.appendChild(iconNode);
		communicationNode.appendChild(descriptionNode);
		communicationNode.appendChild(dropdownIndicator);
	
		// Create the floating submenu for Telecommunication
		const communicationSubmenu = document.createElement("ul");
		communicationSubmenu.className = "floatingList";
		communicationSubmenu.style.display = "none"; // Hidden by default
		communicationSubmenu.style.position = "absolute"; // Position it absolutely
		communicationSubmenu.style.top = "100%"; // Position it directly below the node
	
		// Telecommunication data
		const communicationDetails = [
			{ label: "Fiksne prizemeljske telekomunikacije", value: riskZoneData.fixed, unit: " m" },
			{ label: "Steber/Stolp", value: mapElementData.a_pole, unit: "" },
			{ label: "Enotna baza", value: mapElementData.single_base, unit: "" },
			{ label: "Jašek/Cev", value: mapElementData.shaft, unit: "" },
			{ label: "Pomožni (dodatni) jašek/cev", value: mapElementData.auxiliary, unit: "" },
			{ label: "Električna omarica na enotni bazi", value: mapElementData.cabinet_base, unit: "" },
			{ label: "Električna omarica v steni", value: mapElementData.cabinet_wall, unit: "" },
			{ label: "Pomožna električna omarica (dvojnik)", value: mapElementData.cabinet_duplicate, unit: "" },
			{ label: "Delujoča lokacija", value: mapElementData.location, unit: "" }
		];
	
		// Add each item to the communication submenu
		communicationDetails.forEach(({ label, value, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${value || 0}${unit || ""}`;
			communicationSubmenu.appendChild(listItem);
		});
	
		// Create the grid cell and append the communicationNode and floating submenu
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(communicationNode);
		gridCell.appendChild(communicationSubmenu);
	
		// Toggle submenu visibility on hover
		gridCell.onmouseenter = () => {
			communicationSubmenu.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const submenuRect = communicationSubmenu.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center submenu under the grid cell (slightly adjust to the left by 25px)
			const submenuLeft = gridCellRect.left + (gridCellRect.width / 2) - (submenuRect.width / 2) - 25; // Move 25px to the left
			communicationSubmenu.style.left = `${submenuLeft}px`;
	
			// Prevent submenu from going out of the window (horizontally)
			if (submenuLeft < 0) {
				communicationSubmenu.style.left = "0"; // Align to the left of the viewport
			} else if (submenuLeft + submenuRect.width > windowWidth) {
				communicationSubmenu.style.left = `${windowWidth - submenuRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			communicationSubmenu.style.display = "none";
		};
	
		// Append the grid cell to the infrastructure node
		this.infrastructureNode.append(gridCell);
	};
	
	
	

	
	
	lightingInfrastructure = (mapElementData) => {
		if (!mapElementData) return;
	
		// Create the container for lighting infrastructure
		const lightingNode = document.createElement("div");
		lightingNode.className = "legendRow infrastructure-node";
		lightingNode.style.display = "flex"; // Use flexbox to align items horizontally
		lightingNode.style.alignItems = "center"; // Vertically align items in the center
		lightingNode.style.justifyContent = "flex-start"; // Align items at the start of the container
	
		// Create the icon
		const iconNode = document.createElement("img");
		iconNode.classList.add("icon");
		iconNode.src = "img/bulbIcon.png"; // Replace with the path to your lighting icon
		iconNode.alt = "Lighting Infrastructure Icon";
	
		// Create the description
		const descriptionNode = document.createElement("div");
		descriptionNode.classList.add("description");
		let partsSum = mapElementData.pole + mapElementData.support + mapElementData.base + mapElementData.wall + mapElementData.cabinet + mapElementData.lamp;
		descriptionNode.innerText = "Elementi javne razvetljave: " + partsSum;
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append icon, description, and dropdown indicator to the lightingNode
		lightingNode.appendChild(iconNode);
		lightingNode.appendChild(descriptionNode);
		lightingNode.appendChild(dropdownIndicator);
	
		// Prepare the data for the floating list
		const lightingDetails = [
			{ label: "Steber", value: mapElementData.pole, unit: "" },
			{ label: "Držalo svetilke", value: mapElementData.support, unit: "" },
			{ label: "Temelji", value: mapElementData.base, unit: "" },
			{ label: "Stensko držalo svetilke", value: mapElementData.wall, unit: "" },
			{ label: "Električna omarica za svetilko", value: mapElementData.cabinet, unit: "" },
			{ label: "Svetilka", value: mapElementData.lamp, unit: "" }
		];
	
		// Create the floating list container
		const floatingList = document.createElement("ul");
		floatingList.className = "floatingList";
		floatingList.style.display = "none"; // Hidden by default
		floatingList.style.position = "absolute";
		floatingList.style.top = "100%";
	
		// Populate the floating list
		lightingDetails.forEach(({ label, value, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${value || 0}${unit || ""}`;
			floatingList.appendChild(listItem);
		});
	
		// Create a grid cell to contain both the lighting node and the floating list
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(lightingNode);
		gridCell.appendChild(floatingList);
	
		// Toggle the list visibility on hover
		gridCell.onmouseenter = () => {
			floatingList.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const floatingListRect = floatingList.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center the floating list under the grid cell and adjust left by 25px
			const floatingListLeft = gridCellRect.left + (gridCellRect.width / 2) - (floatingListRect.width / 2) - 25; // Move 25px left
			floatingList.style.left = `${floatingListLeft}px`;
	
			// Prevent the floating list from going out of the window (horizontally)
			if (floatingListLeft < 0) {
				floatingList.style.left = "0"; // Align to the left of the viewport
			} else if (floatingListLeft + floatingListRect.width > windowWidth) {
				floatingList.style.left = `${windowWidth - floatingListRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			floatingList.style.display = "none";
		};
	
		// Append the gridCell to the infrastructure node
		this.infrastructureNode.append(gridCell);
	};
	
	
	
	waterInfrastructureButton = (mapElementData) => {
		if (!mapElementData) return;
	
		// Create the main container for Water Infrastructure
		const waterNode = document.createElement("div");
		waterNode.className = "legendRow infrastructure-node"; // Reuse the same styling classes
	
		// Create the icon element
		const iconNode = document.createElement("img");
		iconNode.classList.add("icon");
		iconNode.src = "img/waterIcon.png"; // Replace with the path to your water icon
		iconNode.alt = "Water Infrastructure Icon"; // Add alt text for accessibility
	
		// Create the description text node
		const descriptionNode = document.createElement("div");
		descriptionNode.classList.add("description");
		descriptionNode.innerText = "Vodne napeljave";
	
		// Create the dropdown indicator (SVG)
		const dropdownIndicator = document.createElement("div");
		dropdownIndicator.classList.add("dropdown-indicator");
		dropdownIndicator.innerHTML = `
			<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 15L6 9H18L12 15Z" fill="gray"/>
			</svg>
		`;
	
		// Append icon, description, and dropdown indicator to the water node
		waterNode.appendChild(iconNode);
		waterNode.appendChild(descriptionNode);
		waterNode.appendChild(dropdownIndicator);
	
		// Create the floating submenu for Water Infrastructure details
		const waterSubmenu = document.createElement("ul");
		waterSubmenu.className = "floatingList";
		waterSubmenu.style.display = "none"; // Hidden by default
		waterSubmenu.style.position = "absolute"; // Position it absolutely
		waterSubmenu.style.top = "100%"; // Position it directly below the node
		waterSubmenu.style.overflowX = "auto"; // Prevent horizontal overflow
	
		// Prepare the data for the floating list
		const waterDetails = [
			{ label: "Odtoki za meteorno vodo", value: mapElementData.drains, unit: " m" },
			{ label: "Odtočni jaški/Odtočne cevi", value: mapElementData.drain_shaft },
			{ label: "Vodovod", value: mapElementData.water, unit: " m" }
		];
	
		// Add each item to the water submenu
		waterDetails.forEach(({ label, value, unit }) => {
			const listItem = document.createElement("li");
			listItem.innerText = `${label}: ${value || 0}${unit || ""}`;
			waterSubmenu.appendChild(listItem);
		});
	
		// Create the grid cell and append the waterNode and floating submenu
		const gridCell = document.createElement("div");
		gridCell.className = "gridCell";
		gridCell.appendChild(waterNode);
		gridCell.appendChild(waterSubmenu);
	
		// Toggle submenu visibility on hover
		gridCell.onmouseenter = () => {
			// Show submenu
			waterSubmenu.style.display = "block";
	
			// Get the position of the grid cell
			const gridCellRect = gridCell.getBoundingClientRect();
			const submenuRect = waterSubmenu.getBoundingClientRect();
			const windowWidth = window.innerWidth;
	
			// Center submenu under the grid cell
			const submenuLeft = gridCellRect.left + (gridCellRect.width / 2) - (submenuRect.width / 2) - 25;
			waterSubmenu.style.left = `${submenuLeft}px`;
	
			// Prevent submenu from going out of the window (horizontally)
			if (submenuLeft < 0) {
				waterSubmenu.style.left = "0"; // Align to the left of the viewport
			} else if (submenuLeft + submenuRect.width > windowWidth) {
				waterSubmenu.style.left = `${windowWidth - submenuRect.width}px`; // Align to the right of the viewport
			}
		};
	
		gridCell.onmouseleave = () => {
			// Hide submenu
			waterSubmenu.style.display = "none";
		};
	
		// Append the grid cell to the infrastructure node
		this.infrastructureNode.append(gridCell);
	};
	
	

}
